/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { useRootWidget } from '../useRootWidget';
import { WidgetComponent } from '../WidgetComponent';
/**
 * Widget viewer.
 */
export function WidgetViewer(props) {
    var _a, _b;
    const [root, key] = useRootWidget((_a = props.rootParams) !== null && _a !== void 0 ? _a : defaultRootParams, props.widgets, false, props.config, (_b = props.data) !== null && _b !== void 0 ? _b : emptyData, props.onDataChange);
    if (root) {
        return React.createElement(WidgetComponent, Object.assign({ key: key }, root));
    }
    else {
        return null;
    }
}
const defaultRootParams = {};
const emptyData = {};
